// extracted by mini-css-extract-plugin
export var container = "d1_f";
export var icon = "d1_cd";
export var text = "d1_c3";
export var tooltip = "d1_dn";